import React from 'react';
import { motion } from 'framer-motion';
const faqs = [{
  q: '¿Es realmente tan sencillo? No soy buena con la tecnología.',
  a: '¡Sí! Por eso creamos el Método Zero-Tech. Solo necesitas saber abrir un correo electrónico e imprimir un documento. Todo lo demás se hace con papel y bolígrafo.'
}, {
  q: '¿Necesito una computadora para usarlo?',
  a: 'No necesariamente. Puedes abrir el correo en tu teléfono o tablet, y pedirle a alguien en una papelería o a un familiar que te lo imprima. Una vez impreso, no necesitas pantallas.'
}, {
  q: '¿Pueden mis hijos ayudarme a llenarlo?',
  a: '¡Por supuesto! De hecho, es una excelente actividad para hacer juntos. Te recomendamos llenarlo con la persona que designarás como tu contacto de emergencia.'
}, {
  q: '¿En qué formato viene?',
  a: 'Recibirás un archivo PDF diseñado específicamente con letras grandes y alto contraste, listo para imprimirse en tamaño carta normal.'
}, {
  q: '¿Es seguro anotar mis contraseñas en papel?',
  a: 'Es mucho más seguro tenerlas en un papel guardado en tu casa (lejos de los hackers de internet) que usar la misma contraseña para todo o anotarlas en notas sueltas en tu teléfono.'
}];
export function FAQ() {
  return <section className="py-20 px-6 md:px-12 lg:px-24 bg-white" data-id="element-31">
      <div className="max-w-3xl mx-auto" data-id="element-32">
        <div className="text-center mb-16" data-id="element-33">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6" data-id="element-34">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-6" data-id="element-35">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-cream p-6 md:p-8 rounded-2xl" data-id="element-36">
              <h3 className="text-xl md:text-2xl font-bold text-navy mb-3" data-id="element-37">
                {faq.q}
              </h3>
              <p className="text-lg text-navy-light leading-relaxed" data-id="element-38">{faq.a}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}